export default __webpack_public_path__ + "static/kouraiScene2-f6a1c8dee8fb08aa0e5e9853543642e7.mp4";